<template>
  <div>
    <TippCard
      hintID="Mitgliederverwaltung_Fristenüberwachung_Erneuerungen_1_V1"
      text="Für Fristeneinträge lassen sich Verlängerungen planen, um den Ablauf von Fristen rechtzeitig zu überwachen."
    >
    </TippCard>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="start">
            <v-col cols="12">
              <v-card>
                <v-card-subtitle>
                  <v-row>
                    <v-col cols="12" sm="5" md="3">
                      <v-text-field
                        v-model="search"
                        outlined
                        append-icon="mdi-magnify"
                        label="Suchen"
                        hide-details="auto"
                        clearable
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            outlined
                            text
                            v-bind="attrs"
                            v-on="on"
                            class="mr-2"
                          >
                            <span v-if="groupBySelector.value == null"
                              >Gruppieren</span
                            >
                            <span v-else>
                              Gruppieren nach
                              <strong class="hidden-sm-and-down">{{
                                groupBySelector.text
                              }}</strong>
                              <v-icon small class="hidden-md-and-up">{{
                                groupBySelector.icon
                              }}</v-icon>
                            </span>
                            <v-icon right>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav>
                          <v-list-item-group
                            v-model="groupBySelector"
                            mandatory
                          >
                            <v-list-item
                              link
                              dense
                              :value="{
                                value: null,
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon dense>mdi-close</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title
                                >Gruppierung aufheben</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item
                              link
                              dense
                              :value="{
                                text: 'Frist',
                                value: 'groupByDeadline',
                                icon: 'mdi-clock',
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon dense>mdi-clock</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Frist </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              link
                              dense
                              :value="{
                                text: 'Person',
                                value: 'groupByPerson',
                                icon: 'mdi-account',
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon dense>mdi-account</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Person</v-list-item-title>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>
                      <v-menu offset-y left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            depressed
                            outlined
                            text
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-icon left>mdi-play-circle</v-icon>Mehrfachaktion
                            für
                            {{
                              helpers.tableSelection.length === 0
                                ? "Auswahl"
                                : `${helpers.tableSelection.length} ${
                                    helpers.tableSelection.length === 1
                                      ? "Eintrag"
                                      : "Einträge"
                                  }`
                            }}

                            <v-icon right>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav dense>
                          <v-list-item
                            link
                            @click="toggleApprovalDialog('selection')"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                :disabled="!helpers.tableSelection.length"
                                >mdi-email-arrow-left</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title
                              >Terminerinnerung versenden</v-list-item-title
                            >
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            link
                            @click="toggleSwapRenewalsDialog('selection')"
                            :disabled="
                              !helpers.tableSelection.length ||
                              helpers.tableSelection.length != 2
                            "
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                :disabled="
                                  !helpers.tableSelection.length ||
                                  helpers.tableSelection.length != 2
                                "
                                >mdi-swap-vertical-circle-outline</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title
                              >Termine tauschen</v-list-item-title
                            >
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            link
                            @click="toggleScheduleRenewalDialog('selection')"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                :disabled="!helpers.tableSelection.length"
                                >mdi-calendar-edit</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title
                              >Termin bearbeiten</v-list-item-title
                            >
                          </v-list-item>
                          <v-divider></v-divider>
                          <v-list-item
                            link
                            @click="toggleCancelRenewalDialog('selection')"
                            :disabled="!helpers.tableSelection.length"
                          >
                            <v-list-item-icon>
                              <v-icon
                                dense
                                :disabled="!helpers.tableSelection.length"
                                >mdi-calendar-remove</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title
                              >Termin absagen (löschen)</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                  v-model="helpers.tableSelection"
                  show-select
                  :items="deadlineEntryRenewalsWithGroups"
                  :headers="headers"
                  item-key="meta.id"
                  :items-per-page="10"
                  sort-by="newDueDate"
                  :sort-desc="true"
                  :search="search"
                  :group-by.sync="groupBySelector.value"
                  :group-desc.sync="groupDesc"
                  max-height="800px auto"
                >
                  <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
                    <th :colspan="headers.length + 1">
                      <v-icon @click="toggle" class="mr-2"
                        >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                      </v-icon>

                      <span v-if="groupBySelector.value == 'groupByPerson'"
                        >{{ items[0].user.displayName }}
                      </span>
                      <span
                        v-else-if="groupBySelector.value == 'groupByDeadline'"
                        >{{ items[0].deadline.title }}</span
                      >
                      ({{ items.length }})
                    </th>
                  </template>
                  <template v-slot:[`item.user.personnelNumber`]="{ item }">
                    <pre>{{ item.user.personnelNumber }}</pre>
                  </template>
                  <template v-slot:[`item.dueDate`]="{ item }">
                    <pre v-if="item.dueDate">{{
                      timestampConverter(item.dueDate)
                    }}</pre>
                  </template>
                  <template
                    v-slot:[`item.scheduledRenewal.timestamp`]="{ item }"
                  >
                    {{
                      timestampConverterWithTime(
                        item.scheduledRenewal.timestamp
                      )
                    }}
                  </template>
                  <template v-slot:[`item.labels`]="{ item }">
                    <v-chip
                      small
                      outlined
                      v-for="(label, index) in item.labels"
                      :key="index"
                      class="py-0 mb-0 mt-1 mr-1"
                    >
                      {{ label }}</v-chip
                    >
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          text
                          depressed
                          class="mr-1 my-1"
                          disabled
                          v-bind="attrs"
                          v-on="on"
                          ><v-icon dense>mdi-email-arrow-left</v-icon>
                        </v-btn>
                      </template>
                      <span>Terminerinnerung senden</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          text
                          depressed
                          class="mr-1 my-1"
                          v-bind="attrs"
                          v-on="on"
                          ><v-icon dense
                            >mdi-swap-vertical-circle-outline</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Termin tauschen</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          text
                          depressed
                          class="mr-1 my-1"
                          @click="toggleScheduleRenewalDialog(item)"
                          v-bind="attrs"
                          v-on="on"
                          ><v-icon dense>mdi-calendar-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Termin bearbeiten</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          text
                          depressed
                          color="error"
                          class="mr-1 my-1"
                          @click="toggleCancelRenewalDialog([item])"
                          v-bind="attrs"
                          v-on="on"
                          ><v-icon dense>mdi-calendar-remove</v-icon>
                        </v-btn>
                      </template>
                      <span>Termin absagen</span>
                    </v-tooltip>
                    <DeadlineEntryRenewalDialog
                      v-if="helpers.showScheduleRenewalDialog"
                      @close="toggleScheduleRenewalDialog()"
                      :deadlineEntry="item"
                      :selection="helpers.tableSelection"
                      hidden
                    ></DeadlineEntryRenewalDialog>
                    <DeadlineEntryRenewalCancelDialog
                      v-if="helpers.showCancellationDialog"
                      @close="toggleCancelRenewalDialog([])"
                      :deadlineEntry="item"
                      :selection="helpers.tableSelection"
                      hidden
                    ></DeadlineEntryRenewalCancelDialog>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <!-- <CustomDialog
      v-if="helpers.approvalDialog.model"
      @close="toggleApprovalDialog()"
      title="Aktualisierung genehmigen"
      :text="`${helpers.tableSelection.length} ${
        helpers.tableSelection.length === 1 ? 'Eintrag ist' : 'Einträge sind'
      } ausgewählt für Genehmigung`"
      :loading="helpers.approvalDialog.loading"
      :errorMessage="helpers.approvalDialog.errorMessage"
      btnText="Genehmigen"
      fullscreenOnMobile
      width="s"
    >
      <template v-slot:content>
        <v-form
          v-model="helpers.approvalDialog.formIsValid"
          ref="approvalDialogForm"
          @submit.prevent="approveUpdateRequests()"
        >
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="helpers.approvalDialog.changes.newDueDate"
              type="date"
              outlined
              hide-details="auto"
              label="Ablaufdatum"
              :rules="[rules.required]"
              class="mb-2"
            ></v-text-field>
          </v-col>
          
          <v-col cols="12">
          
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model.trim="helpers.approvalDialog.changes.newNote"
              outlined
              hide-details="auto"
              clearable
              label="Bemerkungen"
            ></v-text-field>
          </v-col>
        </v-form>
      </template>
    </CustomDialog> -->
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_DEADLINE_ENTRY_RENEWALS } from "@/store/action-types.js";
import DeadlineEntryRenewalDialog from "@/components/member-management/deadlines/DeadlineEntryRenewalDialog.vue";
import DeadlineEntryRenewalCancelDialog from "@/components/member-management/deadlines/DeadlineEntryRenewalCancelDialog.vue";
// import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
export default {
  name: "member-management-deadline-monitoring-tab-approvals",
  components: {
    SupportTools,
    TippCard,
    // CustomDialog,
    DeadlineEntryRenewalDialog,
    DeadlineEntryRenewalCancelDialog,
  },
  data() {
    return {
      groupBySelector: { value: null },
      search: "",
      groupDesc: true,
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
      helpers: {
        tableSelection: [],
        showScheduleRenewalDialog: false,
        showCancellationDialog: false,
        reminderDialog: {
          model: false,
          loading: false,
          errorMessage: "",
        },
        editDialog: {
          model: false,
          loading: false,
          errorMessage: "",
          formIsValid: false,
          data: {
            date: null,
            time: null,
            location: "",
            note: "",
          },
        },
        cancellationDialog: {
          model: false,
          loading: false,
          errorMessage: "",
        },
      },
    };
  },
  computed: {
    headers() {
      const headers = [
        {
          text: "Personalnummer",
          value: "user.personnelNumber",
          divider: true,
        },
        { text: "Vorname", value: "user.firstName", divider: true },
        { text: "Nachname", value: "user.lastName", divider: true },
        {
          text: "Ablaufdatum",
          value: "dueDate",
          divider: true,
        },
        { text: "Labels", value: "labels", divider: true },
        {
          text: "Erneuerungstermin",
          value: "scheduledRenewal.timestamp",
          divider: true,
        },
        {
          text: "Ort",
          value: "scheduledRenewal.location",
          divider: true,
        },
        {
          text: "Bemerkungen",
          value: "scheduledRenewal.note",
          divider: true,
        },
        { text: "Aktionen", value: "actions", divider: true },
      ];

      if (this.groupBySelector.value !== "groupByDeadline") {
        headers.splice(3, 0, {
          text: "Frist",
          value: "deadline.shortTitle",
          divider: true,
        });
      }

      return headers;
    },
    deadlineEntryRenewals() {
      return this.$store.state.memberManagement.deadlineEntryRenewals;
    },
    deadlineEntryRenewalsWithGroups() {
      return this.deadlineEntryRenewals.map((item) => {
        return {
          ...item,
          groupByDeadline: item.deadline.id,
          groupByPerson: item.user.membershipId,
        };
      });
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [
        {
          title: "deadlineEntryRenewals",
          data: this.deadlineEntryRenewals,
        },
      ];
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getDeadlineEntryRenewals();
    },
    getDeadlineEntryRenewals() {
      this.$store.dispatch(
        `${MEMBER_MANAGEMENT}${GET_DEADLINE_ENTRY_RENEWALS}`,
        {
          organizationId: this.$route.params.organizationId,
        }
      );
    },
    timestampConverter(timestamp) {
      try {
        if (!timestamp || typeof timestamp.toDate !== "function") return "-";
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        };
        return timestamp.toDate().toLocaleDateString("de-DE", options);
      } catch (e) {
        return "-";
      }
    },
    timestampConverterWithTime(timestamp) {
      try {
        if (!timestamp || typeof timestamp.toDate !== "function") return "-";
        const options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        };
        return timestamp.toDate().toLocaleDateString("de-DE", options);
      } catch (e) {
        return "-";
      }
    },
    toggleScheduleRenewalDialog() {
      this.helpers.showScheduleRenewalDialog =
        !this.helpers.showScheduleRenewalDialog;
    },
    toggleCancelRenewalDialog(items) {
      this.helpers.showCancellationDialog =
        !this.helpers.showCancellationDialog;
      if (items) {
        this.helpers.tableSelection = items;
      }
    },
  },
};
</script>
